/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ID } from '@gh/common-shared-data';
import { AbstractRestService, RestSettings } from '@gh/core-data';
import { Observable } from 'rxjs';
import { JobInsuranceDto } from './job-insurance.dto';
import { JobInsuranceMapper } from './job-insurance.mapper';

@Injectable()
export class JobInsuranceRestService extends AbstractRestService {
  constructor(private settings: RestSettings) {
    super(settings);
  }

  get(jobId: ID): Observable<JobInsuranceDto> {
    return this.httpGet(
      `${this.bp}/jobs/${jobId}/insurance`,
      JobInsuranceMapper,
    );
  }

  update(jobId: ID, insurance: JobInsuranceDto): Observable<JobInsuranceDto> {
    return this.httpPut(
      `${this.bp}/jobs/${jobId}/insurance`,
      insurance,
      JobInsuranceMapper,
    );
  }
}
